(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["audio-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lf-audio-preview')) {
  customElements.define('lf-audio-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.audio = this.querySelector('audio');
      this.classList.toggle('is-unavailable', !this.audio);
      if (!this.audio) return;
      this.events = new AbortController();
      this.button = this.querySelector('[data-audio-toggle]');
      this.seek = this.querySelector('[data-audio-seek]');
      this.elapsed = this.querySelector('[data-audio-time]');
      this.total = this.querySelector('[data-audio-duration]');
      this.status = this.querySelector('[data-audio-status]');
      this.bars = [...this.querySelectorAll('.lf-audio-spectrum span')];
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.fallback) this.audio.crossOrigin = 'anonymous';
      this.audio.hidden = true;
      this.querySelector('.lf-audio-controls').hidden = false;
      this.button.disabled = false;
      const on = (target, name, action) => target.addEventListener(name, action, { signal: this.events.signal });
      on(this.button, 'click', () => this.audio.paused ? this.play() : this.audio.pause());
      on(this.seek, 'input', () => {
        if (!Number.isFinite(this.audio.duration)) return;
        this.audio.currentTime = Math.min(this.audio.duration, Math.max(0, Number(this.seek.value)));
        this.update();
      });
      on(this.audio, 'loadedmetadata', () => this.update());
      on(this.audio, 'durationchange', () => this.update());
      on(this.audio, 'timeupdate', () => this.update());
      on(this.audio, 'playing', () => {
        this.busy = false;
        this.status.textContent = '';
        this.button.removeAttribute('aria-busy');
        this.classList.add('is-playing');
        this.button.setAttribute('aria-label', this.dataset.pauseLabel);
        document.dispatchEvent(new CustomEvent('lf:audio:play', { detail: { player: this } }));
        this.connectGraph();
        this.animate();
      });
      const stopped = () => {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.classList.remove('is-playing');
        this.button.setAttribute('aria-label', this.dataset.playLabel);
        cancelAnimationFrame(this.frame);
        this.update();
      };
      on(this.audio, 'pause', stopped);
      on(this.audio, 'ended', stopped);
      on(this.audio, 'waiting', () => { this.status.textContent = this.dataset.loadingLabel; });
      on(this.audio, 'error', () => {
        stopped();
        if (!this.fallback && !this.sourceNode) {
          this.fallback = true;
          this.audio.removeAttribute('crossorigin');
          this.audio.load();
          this.play();
        } else this.status.textContent = this.dataset.errorLabel;
      });
      on(document, 'lf:audio:play', event => { if (event.detail.player !== this) this.audio.pause(); });
      on(document, 'visibilitychange', () => { if (document.hidden) this.audio.pause(); });
      on(window, 'pagehide', () => this.audio.pause());
      on(this.motion, 'change', () => {
        cancelAnimationFrame(this.frame);
        if (!this.motion.matches && !this.audio.paused) this.animate();
      });
      this.update();
    }
    async play() {
      if (this.busy) return;
      this.busy = true;
      this.status.textContent = this.dataset.loadingLabel;
      this.button.setAttribute('aria-busy', 'true');
      if (this.audio.ended) this.audio.currentTime = 0;
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!this.fallback && AudioContextClass) {
        try {
          this.context ||= new AudioContextClass();
          this.context.resume().then(() => {
            if (this.isConnected && !this.audio.paused) { this.connectGraph(); this.animate(); }
          }).catch(() => {});
        } catch {}
      }
      try { await this.audio.play(); }
      catch (error) {
        if (!this.isConnected || error.name === 'AbortError') return;
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        if (!this.audio.error) this.status.textContent = this.dataset.errorLabel;
      }
    }
    connectGraph() {
      if (this.fallback || this.sourceNode || this.context?.state !== 'running') return;
      try {
        this.analyser = this.context.createAnalyser();
        this.analyser.fftSize = 256;
        this.analyser.smoothingTimeConstant = .78;
        this.sourceNode = this.context.createMediaElementSource(this.audio);
        this.sourceNode.connect(this.analyser);
        this.analyser.connect(this.context.destination);
        this.frequencies = new Uint8Array(this.analyser.frequencyBinCount);
      } catch {
        if (this.sourceNode) this.sourceNode.connect(this.context.destination);
        this.analyser = null;
      }
    }
    animate() {
      cancelAnimationFrame(this.frame);
      if (!this.isConnected || this.audio.paused || !this.analyser || this.motion.matches || document.body.dataset.motion === 'false') return;
      this.analyser.getByteFrequencyData(this.frequencies);
      this.bars.forEach((bar, index) => {
        const bin = Math.min(this.frequencies.length - 1, Math.floor(Math.pow(index / this.bars.length, 1.6) * this.frequencies.length));
        bar.style.setProperty('--level', Math.max(.08, this.frequencies[bin] / 255));
      });
      this.frame = requestAnimationFrame(() => this.animate());
    }
    update() {
      const duration = this.audio.duration;
      const time = this.audio.currentTime || 0;
      const format = seconds => `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
      this.elapsed.textContent = format(time);
      this.seek.setAttribute('aria-valuetext', format(time));
      if (!Number.isFinite(duration) || duration <= 0) return;
      this.seek.disabled = false;
      this.seek.max = String(duration);
      this.seek.value = String(time);
      this.total.textContent = format(duration);
    }
    disconnectedCallback() {
      this.audio?.pause();
      this.events?.abort();
      this.events = null;
      cancelAnimationFrame(this.frame);
      if (this.sourceNode) this.audio.replaceWith(this.audio.cloneNode(true));
      this.sourceNode?.disconnect();
      this.analyser?.disconnect();
      this.context?.close().catch(() => {});
      this.context = null;
      this.sourceNode = null;
      this.analyser = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
